export default __webpack_public_path__ + "static/black-cork-19b4f1c533182336e4346b172f553212.png";